import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from 'rxjs';
import { UnsuccessfulMerchants } from './merchants';
import { SharedService } from "./../shared/services/shared.service";
import { StorageService } from "src/app/core/helpers/storage.service";
import { environment } from "../../../../../environments/environment";
import { Config } from "../../../../core/Config";
import { MerchantDetails } from './interface/merchant';
import { ApiResponse } from '../shared/models/api-response';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: "root",
})
export class ManageMerchantsService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private storageService: StorageService,
    private sharedService: SharedService,
    private config: Config
  ) {}

  getMerchants(pageIndex: number, pageSize: number, searchParams?): Observable<ApiResponse<MerchantDetails[]>> {
    let params = new HttpParams();

    if (pageIndex) {
      params = params.append("pageIndex", pageIndex);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (searchParams?.merchantId) {
      params = params.append("merchantId", searchParams.merchantId);
    }

    return this.httpClient
      .get<ApiResponse<MerchantDetails[]>>(BASE_URL + this.config.getMerchants, { params })
      .pipe(
        map((merchants) => {
          return merchants;
        })
      );
  }

  createMerchant(merchantDetails) {
    return this.httpClient.post(BASE_URL + this.config.createMerchant, merchantDetails);
  }
  updateMerchant(merchantDetails) {
    return this.httpClient.post(BASE_URL + this.config.updateMerchant, merchantDetails);
  }
  deleteMerchant(code: string) {
    return this.httpClient.post(BASE_URL + this.config.deleteMerchant + '/' + code, {});
  }
  disableMerchant(merchantId: string) {
    let params = new HttpParams()
      .append("merchantId", merchantId);
    return this.httpClient.patch(BASE_URL + this.config.disableMerchant, "/", {  params  });
  }
  enalbeMerchant(merchantId: string) {
    let params = new HttpParams()
      .append("merchantId", merchantId);
    return this.httpClient.patch(BASE_URL + this.config.enableMerchant, "/", { params  });
  }
  bulkUpload(file, clientId?: number) {
    let params = new HttpParams();
    if (clientId) {
      params = params.append("clientId", clientId);
    }
    const formData = new FormData();
    formData.append("file", file);
    return this.httpClient.post(BASE_URL + this.config.createBulkMerchant, formData, {params})
    .pipe(
      map((unsuccessfulMerchants: UnsuccessfulMerchants) => {
        return unsuccessfulMerchants;
      })
    );
  }
}
